import {
    EQUIPMENT_ATTACHMENT,
    HORIZONTAL_SIGN_ATTACHMENT,
    RISK_ZONE_CLUSTER_ATTACHMENT,
    ROADWORK_ATTACHMENT,
    VERTICAL_SIGN_POLE_ATTACHMENT,
} from "../constants/modules"

import { documentQueryKeys } from "./queries/queryKeys"


export function invalidateDocumentProject(queryClient, network) {
    const queryKey = documentQueryKeys.project()
    queryKey.push({ network: network?.slug })
    queryClient.invalidateQueries({
        queryKey: queryKey,
    })
}

export function invalidateDocumentsList(queryClient, network) {
    const queryKey = documentQueryKeys.list()
    queryKey.push({ network: network?.slug })
    queryClient.invalidateQueries({
        queryKey: queryKey,
    })
}

export async function invalidateAttachedObject(queryClient, document) {
    const queriesToInvalidate = []
    switch (document.attached_object_content_type) {
        case VERTICAL_SIGN_POLE_ATTACHMENT:
            queriesToInvalidate.push({ queryKey: ["verticalSigning", "pole", document.attached_object_uuid] })
            break
        case HORIZONTAL_SIGN_ATTACHMENT:
            queriesToInvalidate.push({ queryKey: ["horizontalSign", "feature", document.attached_object_uuid] })
            break
        case EQUIPMENT_ATTACHMENT:
            queriesToInvalidate.push({ queryKey: ["equipment", "feature", document.attached_object_uuid] })
            break
        case ROADWORK_ATTACHMENT:
            queriesToInvalidate.push({ queryKey: ["roadworks", "roadwork", document.attached_object_uuid] })
            break
        case RISK_ZONE_CLUSTER_ATTACHMENT:
            queriesToInvalidate.push({
                predicate: (query) => {
                    return query.queryKey[0] === "riskZones"
                        && query.queryKey[1] === "feature"
                        && !query.queryKey[3]?.as_geojson
                        && query.state.data?.find((cluster) => cluster.uuid === document.attached_object_uuid)
                },
            })
            break
    }
    for (const query of queriesToInvalidate) {
        queryClient.invalidateQueries({
            ...query,
        })
    }
}